import {css} from "@panda/css";

export const popupPanelMotionEnterStyle = css({
    animationDuration: "var(--transition-duration-fast)",
    animationTimingFunction: "ease-out",
    animationFillMode: "both"
});

export const popupPanelMotionExitStyle = css({
    animationDuration: "var(--transition-duration-fast)",
    animationTimingFunction: "ease-in",
    animationFillMode: "both"
});

export const popupPanelFadeInStyle = css({
    animationName: "popupPanelFadeIn"
});

export const popupPanelFadeOutStyle = css({
    animationName: "popupPanelFadeOut"
});

export const popupPanelOverlayFadeInStyle = css({
    animationName: "bottomSheetOverlayFadeIn"
});

export const popupPanelOverlayFadeOutStyle = css({
    animationName: "bottomSheetOverlayFadeOut"
});
import {css} from "@panda/css";

export const popupPanelMotionEnterStyle = css({
    animationDuration: "var(--transition-duration-fast)",
    animationTimingFunction: "ease-out",
    animationFillMode: "both"
});

export const popupPanelMotionExitStyle = css({
    animationDuration: "var(--transition-duration-fast)",
    animationTimingFunction: "ease-in",
    animationFillMode: "both"
});

export const popupPanelFadeInStyle = css({
    animationName: "popupPanelFadeIn"
});

export const popupPanelFadeOutStyle = css({
    animationName: "popupPanelFadeOut"
});

export const popupPanelOverlayFadeInStyle = css({
    animationName: "bottomSheetOverlayFadeIn"
});

export const popupPanelOverlayFadeOutStyle = css({
    animationName: "bottomSheetOverlayFadeOut"
});
